export const useShippingDetailFooter = () => {
  return {};
};
